import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  SdfBox,
  SdfBoxStack,
  SdfFlagLayout,
  SdfButton,
  SdfIcon,
} from '@waypoint/react-components';
import { getLocaleObjFromPropKey } from '../../util/locale';
import { constants } from '../login/login-comp-constants';
import {
  EMAIL_AUTHENTICATOR_PICKED,
  MOBILE_AUTHENTICATOR_PICKED,
  PUSH_AUTHENTICATOR_PICKED,
  GET_ADP_MOBILE_APP,
  PUSH_OPTION_SHOWN,
  ADDITIONAL_OPTIONS_SELECTED,
} from '../../util/pendo/constants';
import { trackEvents } from '../../util/misc/common';

function ChannelListForm(props) {
  const {
    sendOTP,
    showQRCode,
    channelsDisplaySession,
    channelsDisplayChallenge,
    currentlySending,
    isAppView,
    pushRegistration,
    redirectURL,
    locale,
    isMobileDevice,
  } = props;
  const { authenticators, mobileAppRegistered } = channelsDisplayChallenge;
  let itemsDisplayed = 0;

  const mobiles = [];
  const emails = [];
  const pushOption = [];
  const regpushOption = [];
  const typeResponse = 'AUTHENTICATOR_PICKER_RESPONSE';

  const { OLP_BUTTON_LINK } = constants;

  authenticators.map((item) => {
    if (item.type === 'PUSH') {
      pushOption.push(item);
    } else if (item.type === 'EMAIL') {
      emails.push(item);
    } else if (item.type === 'MOBILE') {
      mobiles.push(item);
    } else if (item.type === 'REG_PUSH') {
      regpushOption.push(item);
    }

    return item;
  });

  const regPushProps = {
    type: 'REG_PUSH',
    data: regpushOption,
    listButton: {
      iconName: 'brand-adp',
      id: 'regpushListButton',
      iconClassName:
        'text-4xl text-brand-secondary shadow-2 rounded-md box-border',
    },
    button: {
      id: 'regpush-button',
      style: 'link',
    },
    title: {
      id: 'stepup.regpush.title',
      defaultMessage: 'Get ADP Mobile App',
      description: 'stepup reg_push text',
    },
    subtitle: {
      id: 'stepup.regpush.subtitle',
      defaultMessage: 'Scan QR code to install the app',
      description: 'Requires ADP mobile app',
    },
  };

  const channels = [
    {
      type: 'PUSH',
      data: pushOption,
      listButton: {
        iconName: 'brand-adp',
        id: 'pushListButton',
        iconClassName:
          'text-4xl text-inverse-secondary bg-action-destructive-600 shadow-2 rounded-lg box-border',
      },
      button: {
        id: 'email-button',
        style: 'link',
      },
      title: {
        id: 'stepup.push.title',
        defaultMessage: 'Authenticate with the ADP mobile app',
        description: 'stepup email text',
      },
      subtitle: {
        id: 'stepup.push.subtitle',
        defaultMessage: 'Preferred method for ease and security.',
        description: 'Requires ADP mobile app',
      },
      communicator: 'address',
    },
    {
      type: 'Mobile',
      data: mobiles,
      listButton: {
        iconName: 'ext-mdi-smartphone',
        id: 'mobileListButton',
        iconClassName: 'text-3xl text-link scale-75 sm:transform',
      },
      button: {
        id: 'mobile-button',
        style: 'link',
      },
      title: {
        id: 'stepup.mobile.text',
        defaultMessage: 'Send me a text.',
        description: 'stepup mobile text',
      },
      subtitle: {
        id: 'stepup.mobile.subtext',
        defaultMessage: '(Message and data rates may apply.)',
        description: '(Message and data rates may apply.)',
      },
      communicator: 'formattedNumber',
    },
    {
      type: 'Email',
      data: emails,
      listButton: {
        iconName: 'action-email',
        id: 'emailListButton',
        iconClassName: 'text-3xl text-link scale-75 sm:transform',
      },
      button: {
        id: 'email-button',
        style: 'link',
      },
      title: {
        id: 'stepup.email.text',
        defaultMessage: 'Send me an email.',
        description: 'stepup email text',
      },
      communicator: 'address',
    },
  ];
  const noChannelFound = (emails === undefined || emails.length === 0)
    && (mobiles === undefined || mobiles.length === 0)
    && (pushOption === undefined || pushOption.length === 0)
    && (regpushOption === undefined || regpushOption.length === 0);

  const onSelectChannel = () => {
    if (mobiles.length > 0) {
      return mobiles[0].formattedNumber;
    }
    if (emails.length > 0) {
      return emails[0].address;
    }
    return '';
  };

  useState(onSelectChannel());
  const [hide, setHide] = useState(true);

  const onSendOTP = (
    authenticatorId,
    authenticatorType,
    authenticatorFormat,
    application,
  ) => {
    if (authenticatorType === 'MOBILE') {
      trackEvents(MOBILE_AUTHENTICATOR_PICKED);
    } else if (authenticatorType === 'EMAIL') {
      trackEvents(EMAIL_AUTHENTICATOR_PICKED);
    } else if (authenticatorType === 'PUSH') {
      trackEvents(PUSH_AUTHENTICATOR_PICKED);
    }
    return (
      !currentlySending
      && sendOTP(
        typeResponse,
        authenticatorId,
        authenticatorType,
        authenticatorFormat,
        channelsDisplaySession,
        application,
      )
    );
  };

  const buttonUrl = pushRegistration && pushRegistration.buttonUrl
    ? getLocaleObjFromPropKey(pushRegistration.buttonUrl, locale)
    : OLP_BUTTON_LINK;

  const onMobileRedirect = () => {
    redirectURL(buttonUrl, true);
  };

  const showPushToMobile = () => {
    trackEvents(GET_ADP_MOBILE_APP);
    if (buttonUrl && isMobileDevice) {
      onMobileRedirect();
    } else {
      showQRCode();
    }
  };

  const showOptions = () => {
    setHide(false);
    trackEvents(ADDITIONAL_OPTIONS_SELECTED);
  };
  const hideOptions = () => {
    setHide(true);
  };
  useEffect(() => {
    if (pushOption === undefined || pushOption.length === 0) {
      setHide(false);
    }
  }, [pushOption]);
  useEffect(() => {
    if (!(pushOption === undefined || pushOption.length === 0)) {
      trackEvents(PUSH_OPTION_SHOWN);
    }
  }, []);
  return (
    <div
      id="frmLogin"
      className="flex flex-col"
    >
      <div>
        { noChannelFound ? (
          <div className="text-right">
            { ' ' }
            <FormattedMessage
              id="stepup.nochannel.found.text"
              defaultMessage="No Channel Found"
              description="stepup nochannel found text"
            />
            { ' ' }
          </div>
        ) : (
          <div>
            <div className="md:font-medium md:not-italic text-md md:leading-md mt-2">
              { ' ' }
              <FormattedMessage
                id="stepup.verify.subtext"
                defaultMessage="To protect your information, select an option to verify your identity"
                description="stepup Subtext"
              />
            </div>
            <div
              className={
                isAppView ? 'flex-row flex-1 pt-8' : 'mx-auto my-0 pt-4 mt-2'
              }
            >
              <SdfBoxStack>
                <div>
                  { mobileAppRegistered === 'N' && (
                    <SdfBox
                      id={ regPushProps.listButton.id }
                      data-testid={ regPushProps.listButton.id }
                      style={ { cursor: 'pointer' } }
                      variant="shadowed"
                      tabIndex={ 0 }
                      role="button"
                      class="supports-focus-visible rounded-xl hydrated box-bordered hover:bg-action-primary-50 focus:bg-action-primary-50"
                      onClick={ () => {
                        showPushToMobile();
                      } }
                      onKeyDown={ (event) => {
                        event.keyCode === 13 && showPushToMobile();
                      } }
                    >
                      <SdfFlagLayout>
                        <SdfIcon
                          slot="graphic"
                          shape="square"
                          icon={ regPushProps.listButton.iconName }
                          class={ regPushProps.listButton.iconClassName }
                        />
                        <div
                          className="text-link text-lg"
                          slot="headline"
                        >
                          <FormattedMessage
                            id={ regPushProps.title.id }
                            defaultMessage={ regPushProps.title.defaultMessage }
                            description={ regPushProps.title.description }
                          />
                        </div>
                        <p
                          slot="supporting-content"
                          className="m-0 text-lg pt-2"
                        >
                          <FormattedMessage
                            id={ regPushProps.subtitle.id }
                            defaultMessage={
                              regPushProps.subtitle.defaultMessage
                            }
                            description={ regPushProps.subtitle.description }
                          />
                        </p>
                        <SdfIcon
                          slot="action"
                          icon="nav-page-next"
                          class="text-2xl text-link"
                        />
                      </SdfFlagLayout>
                    </SdfBox>
                  ) }
                </div>
                { channels.map((channel) => channel.data.map((item, index) => {
                  const shouldRender = (item.type === 'PUSH' && hide === true) || hide === false;
                  if (
                    shouldRender
                      && hide === false
                      && (item.type === 'EMAIL' || item.type === 'MOBILE')
                  ) {
                    itemsDisplayed += 1;
                  }
                  return shouldRender ? (
                    <div
                      key={ `${channel.type}-${item.authenticatorId || index}` }
                    >
                      { item.type === 'PUSH' && (
                      <SdfBox
                        id={ channel.listButton.id }
                        data-testid={ channel.listButton.id }
                        style={ { cursor: 'pointer' } }
                        variant="shadowed"
                        tabIndex={ 0 }
                        role="button"
                        class="supports-focus-visible rounded-xl hydrated box-bordered hover:bg-action-primary-50 focus:bg-action-primary-50"
                        onClick={ () => {
                          onSendOTP(
                            item.authenticatorId,
                            item.type,
                            item[channel.communicator],
                            item.application,
                          );
                        } }
                        onKeyDown={ (event) => {
                          event.keyCode === 13
                                && onSendOTP(
                                  item.authenticatorId,
                                  item.type,
                                  item[channel.communicator],
                                  item.application,
                                );
                        } }
                      >
                        <SdfFlagLayout>
                          <SdfIcon
                            slot="graphic"
                            shape="square"
                            icon={ channel.listButton.iconName }
                            class={ channel.listButton.iconClassName }
                          />
                          <div
                            className="text-link text-lg"
                            slot="headline"
                          >
                            <FormattedMessage
                              id={ channel.title.id }
                              defaultMessage={ channel.title.defaultMessage }
                              description={ channel.title.description }
                            />
                          </div>
                          <p
                            slot="supporting-content"
                            className="m-0 text-lg pt-2"
                          >
                            <FormattedMessage
                              id={ channel.subtitle.id }
                              defaultMessage={
                                    channel.subtitle.defaultMessage
                                  }
                              description={ channel.subtitle.description }
                            />
                          </p>
                          <SdfIcon
                            slot="action"
                            icon="nav-page-next"
                            class="text-2xl text-link"
                          />
                        </SdfFlagLayout>
                      </SdfBox>
                      ) }
                      { item.type === 'PUSH'
                          && hide === true
                          && emails.length + mobiles.length != 0 && (
                            <div className="flex justify-center pt-5">
                              <SdfButton
                                id="ShowOptions"
                                action="standard"
                                emphasis="tertiary"
                                size="sm"
                                variant="contained"
                                icon="action-expand"
                                icon-placement="before"
                                onClick={ () => showOptions() }
                                onKeyPress={ () => showOptions() }
                              >
                                <FormattedMessage
                                  id="PUSH_SHOW_ADDITIONALDETAILS"
                                  defaultMessage="Show additional options"
                                  description="show additional options"
                                />
                              </SdfButton>
                            </div>
                      ) }
                      { hide === false
                          && (item.type === 'EMAIL' || item.type === 'MOBILE') && (
                            <SdfBox
                              id={ channel.listButton.id }
                              data-testid={ channel.listButton.id }
                              style={ { cursor: 'pointer' } }
                              variant="shadowed"
                              role="button"
                              tabIndex={ 0 }
                              class="supports-focus-visible rounded-xl hydrated box-bordered hover:bg-action-primary-50 focus:bg-action-primary-50"
                              onClick={ () => {
                                onSendOTP(
                                  item.authenticatorId,
                                  item.type,
                                  item[channel.communicator],
                                );
                              } }
                              onKeyDown={ (event) => {
                                if (event.keyCode === 13) {
                                  onSendOTP(
                                    item.authenticatorId,
                                    item.type,
                                    item[channel.communicator],
                                  );
                                }
                              } }
                            >
                              <SdfFlagLayout>
                                <SdfIcon
                                  slot="graphic"
                                  shape="square"
                                  icon={ channel.listButton.iconName }
                                  class={ channel.listButton.iconClassName }
                                />
                                <div
                                  className="text-link"
                                  slot="headline"
                                >
                                  <FormattedMessage
                                    id={ channel.title.id }
                                    defaultMessage={
                                      channel.title.defaultMessage
                                    }
                                    description={ channel.title.description }
                                  />
                                </div>
                                <p
                                  slot="supporting-content"
                                  className="m-0 text-lg pt-2"
                                >
                                  { item[channel.communicator] }

                                  { channel.subtitle && (
                                    <FormattedMessage
                                      id={ channel.subtitle.id }
                                      defaultMessage={
                                        channel.subtitle.defaultMessage
                                      }
                                      description={ channel.subtitle.description }
                                    />
                                  ) }
                                </p>
                                <SdfIcon
                                  slot="action"
                                  icon="nav-page-next"
                                  class="text-2xl text-link"
                                />
                              </SdfFlagLayout>
                            </SdfBox>
                      ) }
                      { itemsDisplayed === emails.length + mobiles.length
                          && hide === false
                          && pushOption != undefined
                          && pushOption.length != 0 && (
                            <div className="flex justify-center pt-5">
                              { ' ' }
                              <SdfButton
                                id="HideOptions"
                                action="standard"
                                emphasis="tertiary"
                                size="sm"
                                variant="contained"
                                icon="action-collapse"
                                icon-placement="before"
                                onClick={ () => hideOptions() }
                                onKeyPress={ () => hideOptions() }
                              >
                                <FormattedMessage
                                  id="PUSH_HIDE_ADDITIONALDETAILS"
                                  defaultMessage="Hide additional options"
                                  description="hide additional options"
                                />
                              </SdfButton>
                            </div>
                      ) }
                    </div>
                  ) : null;
                })) }
              </SdfBoxStack>
            </div>
          </div>
        ) }
      </div>
    </div>
  );
}

ChannelListForm.propTypes = {
  channelsDisplayChallenge: PropTypes.shape({
    type: PropTypes.string,
    mobileAppRegistered: PropTypes.string,
    authenticators: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        authenticatorId: PropTypes.string,
        address: PropTypes.string,
        application: PropTypes.string,
      }),
    ),
  }),
  sendOTP: PropTypes.func.isRequired,
  channelsDisplaySession: PropTypes.string,
  currentlySending: PropTypes.bool,
  isAppView: PropTypes.bool,
  showQRCode: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool,
  pushRegistration: PropTypes.shape({
    buttonUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  redirectURL: PropTypes.func.isRequired,
  locale: PropTypes.string,
};

export default ChannelListForm;
